import Const from '@/helper/const'
import { custAxios } from './genericApi'

export default {
  getAllRequestFieldsBySystemProvider (idProviderFlow) {
    return custAxios().get(`${Const.API_BATCH_PROCESSING}/getAllRequestFieldsBySystemProvider/${idProviderFlow}?internalField=false`)
  }
}
